<div class="side-menu">
  <tds-side-menu aria-label="Side menu" id="side-menu" persistent open="true" open="{{ isMenuOpened }}">
    <tds-side-menu-overlay
      slot="overlay"
      (click)="mobileMenuAction(false)"
    ></tds-side-menu-overlay>
    <tds-side-menu-close-button
      slot="close-button"
      aria-label="Close drawer menu"
      (click)="mobileMenuAction(false)"
    ></tds-side-menu-close-button>

    <tds-side-menu-item *ngFor="let item of menuItems" 
                        [selected]="(selectedMenu$ | async) === item.label">
      <button (click)="navigate(item.label, item.path)">
        <tds-icon [name]="item.icon" size="24px"></tds-icon>
        {{ item.label }}
      </button>
    </tds-side-menu-item>

    <tds-side-menu-collapse-button slot="sticky-end">
      Collapse
    </tds-side-menu-collapse-button>
  </tds-side-menu>
</div>
